'use client';

import { useAtomValue } from 'jotai';
import {
  NewsletterForm,
  type NewsletterFormProps,
} from '../_components/newsletter-form';
import {
  enableHomeNewsletterAtom,
  homeNewsletterDescriptionAtom,
  homeNewsletterTitleAtom,
} from '../../_components/design-state';

export function HomeNewsletter(props: NewsletterFormProps) {
  const enableHomeNewsletter = useAtomValue(enableHomeNewsletterAtom);
  const homeNewsletterTitle = useAtomValue(homeNewsletterTitleAtom);
  const homeNewsletterDescription = useAtomValue(homeNewsletterDescriptionAtom);
  if (!enableHomeNewsletter) {
    return <></>;
  }
  return (
    <NewsletterForm
      {...props}
      title={homeNewsletterTitle}
      description={homeNewsletterDescription}
      className="home-newsletter"
    />
  );
}
